import ResetForm from './ResetForm'

export {
  ResetForm
}



// WEBPACK FOOTER //
// ./src/views/Reset/components/index.js